import React from 'react';
import { useStoreContext } from '../../Contexts/StoreContext';
import { formatCurrentAddress } from '../../Utils/Formatters';
import { ORDER_TYPE_LABELS } from '../../Utils/Constants/Service';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { sanitizeText } from '../../Utils/Helpers';
import CardStoreList from './CardStoreList';
import SlotAddressChoice from './SlotAddressChoice';
import { useNavigate } from 'react-router-dom';
import { useStoreHook } from '../../Hooks/StoreHook';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import ButtonPrimary from '../Form/ButtonPrimary';
import Button from '../Form/Button';
import { useTranslation } from 'react-i18next';

interface BoxContentOrderTypeAndCurrentAddressProps {
    onContinue: CallableFunction;
}

const BoxContentOrderTypeAndCurrentAddress = ({ onContinue }: BoxContentOrderTypeAndCurrentAddressProps) => {

    const { t } = useTranslation();
    const { currentAddress, currentStore } = useStoreContext();
    const { setShowStart } = useLayoutContext();
    const { getLinkToHome } = useStoreHook();
    const { orderType, isDelivery, isDinein } = useOrderTypeContext();
    const navigate = useNavigate();

    const orderTypeLabel = ORDER_TYPE_LABELS[orderType as keyof typeof ORDER_TYPE_LABELS];
    const text1 = isDelivery
        ? `${t('start.order_type_and_current_address.order_type_selected_delivery_title')} <span class='font-bold text-shopfood-title'>${orderTypeLabel}</span>`
        : `${t('start.order_type_and_current_address.order_type_selected_title')} <span class='font-bold text-shopfood-title'>${orderTypeLabel}</span>`;
    const text2 = isDelivery
        ? t('start.order_type_and_current_address.order_type_selected_delivery_subtitle')
        : t('start.order_type_and_current_address.order_type_selected_subtitle');

    const currentAddressChoice = {
        main_text: currentAddress?.title,
        secondary_text: formatCurrentAddress(currentAddress),
        title: currentAddress?.title
    };

    const handleClose = () => {
        setShowStart(false);
        navigate(getLinkToHome());
    }

    const handleContinue = () => {
        onContinue();
    }

    if (!orderType) return null;

    return (
        <div className='grid gap-4 place-items-center'>

            <p className='gap-1 text-center leading-none font-medium text-lg px-2' dangerouslySetInnerHTML={{ __html: sanitizeText(text1) }} />

            { (isDelivery && currentAddress) &&
                <section className='w-full h-full max-h-max'>
                    <SlotAddressChoice isCurrent address={currentAddressChoice} onHandleClick={handleClose} />
                </section>
            }

            { (currentStore && isDinein) && 
                <CardStoreList orderType={orderType} onCardClick={handleClose} store={currentStore} />
            }

            <h1 className="text-xl mt-4 px-2 font-bold leading-none text-shopfood-title text-center">{ text2 }</h1>

            <div className='flex gap-2 px-2 w-full'>
                <ButtonPrimary onClick={handleContinue} className="w-full text-nowrap">
                    {t('start.order_type_and_current_address.button_confirm_label')}
                </ButtonPrimary>
                <Button onClick={handleClose} className="w-full">
                    {t('start.order_type_and_current_address.button_cancel_label')}
                </Button>
            </div>
        </div>
    );
};

export default BoxContentOrderTypeAndCurrentAddress;
